import { isValid, parseISO } from 'date-fns';
import type { CutOff, DominoBookingParams } from 'state/secondaryMarket/cpOrder/referential/product/product.model';

import type { CutOffResponse, DominoVoiceBookingParamsResponse } from './model';

export function mapBookingParamsFromResponse(response: DominoVoiceBookingParamsResponse): DominoBookingParams {
  return {
    ...response,
    cutOff: mapCutoffFromResponse(response.cutOff),
  };
}

function parseCutoff(value: string | null | undefined): Date | undefined {
  if (value !== null && value !== undefined && value !== '') {
    const date = parseISO(value);
    if (isValid(date)) {
      return date;
    }
  }
  return undefined;
}

function mapCutoffFromResponse(response: CutOffResponse | undefined): CutOff | undefined {
  if (response === undefined) {
    return undefined;
  }
  const { nextCutOff, ...others } = response;

  return {
    ...others,
    nextCutOff: parseCutoff(nextCutOff),
  };
}
